export default "__VITE_ASSET__B7vdsv2K__"